import { ReactElement, ReactNode } from "react";

import Table, { RowActions } from "~frontend/components/Table";

import { UserInvite } from "./types";

export default function UserInviteTable<T extends UserInvite>({
  userInvites,
  totalCount,
  rowsPerPage,
  onChangeRowsPerPage,
  page,
  onChangePage,
  renderRole,
  renderActions,
}: {
  userInvites: T[];
  totalCount: number;
  rowsPerPage: number;
  onChangeRowsPerPage: (rpp: number) => void;
  page: number;
  onChangePage: (p: number) => void;
  renderRole: (invite: T) => ReactNode;
  renderActions: (invite: T) => RowActions<T>;
}): ReactElement {
  return (
    <Table
      columns={[
        { key: "name", title: "Name", renderValue: user => user.fullName },
        { key: "email", title: "Email", renderValue: user => user.email },
        { key: "role", title: "Role", renderValue: renderRole },
      ]}
      rows={userInvites}
      rowActions={renderActions}
      totalCount={totalCount}
      rowsPerPage={rowsPerPage}
      onChangeRowsPerPage={onChangeRowsPerPage}
      page={page}
      onChangePage={onChangePage}
    />
  );
}
